import { render, staticRenderFns } from "./MenuHeaderComponent.vue?vue&type=template&id=7326c943"
import script from "./MenuHeaderComponent.vue?vue&type=script&lang=js"
export * from "./MenuHeaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports